import { observer } from 'mobx-react-lite'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { SaveSectionDialogViewModel } from './SaveSectionDialogViewModel'

export { SaveSectionDialogViewModel } from './SaveSectionDialogViewModel'

interface SaveSectionDialogProps {
  vm: SaveSectionDialogViewModel
  testId?: string
}

export const SaveSectionDialog = observer(function SaveSectionDialog({
  vm,
  testId,
}: SaveSectionDialogProps) {
  const isSaving = vm.saveAndContinue.pending

  return (
    <ModalDialog
      isOpen={vm.modal.showing}
      onClose={vm.closeDialog}
      isDismissable={!isSaving}
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          Save your {vm.sectionLabel} info before moving on
        </ModalDialogTitle>
        <ModalDialogDescription>
          Make sure this section is accurate and all required fields are
          completed.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter sticky bordered compact>
        <ModalDialogActions>
          <Button
            label="Save changes"
            variant="default"
            onPress={vm.saveAndContinue}
            isPending={isSaving}
            testId={testId ? `${testId}-save-button` : undefined}
          />
          <Button
            label="Continue without saving"
            variant="outline"
            onPress={vm.continueWithoutSaving}
            isDisabled={isSaving}
            testId={testId ? `${testId}-continue-button` : undefined}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
})
